import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[insert-directive]',
})
export class InsertionDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
